var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "../hooks/useConfig";
import theme from "../ui/theme";
import { IncomeCaptureFormProvider } from "./IncomeCaptureFormProvider";
var IncomeCaptureDefaultProviders = function (_a) {
    var config = _a.config, children = _a.children;
    return (_jsx(ConfigProvider, __assign({ value: config }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(IncomeCaptureFormProvider, { children: children }) })) })));
};
export default IncomeCaptureDefaultProviders;
